import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { message, Popconfirm, Table, TableProps } from "antd";
import Spinner from "../../components/shared/Spinner/Spinner";
import { SubscriberDataType } from "../../interfaces/admin.interface";
import { SubscribersService } from "../../services/subscribers.service";

const Subscribers = () => {
  const [subscribers, setSubscribers] = useState<SubscriberDataType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const fetchSubscribersData = async () => {
    setLoading(true);
    SubscribersService.getAllSubscribers()
      .then((response) => {
        if (Array.isArray(response?.data?.data)) {
          const dataWithKeys = response?.data?.data?.map(
            (item: SubscriberDataType, index: number) => ({
              ...item,
              key: index + 1,
            })
          );
          setSubscribers(dataWithKeys);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchSubscribersData();
  }, []);

  const handleDeleteClick = async (record: SubscriberDataType) => {
    try {
      await SubscribersService.deleteSubscriber(record.id);
      await fetchSubscribersData();
      message.success("Abunəçi uğurla silindi!");
    } catch (error) {
      message.error("Abunəçini silmək alınmadı.");
    }
  };

  const columns: TableProps<SubscriberDataType>["columns"] = [
    {
      title: "№",
      dataIndex: "key",
      sorter: (a, b) => (a.key ?? 0) - (b.key ?? 0),
    },
    {
      title: "E-poçt",
      dataIndex: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: "Abunə tarixi",
      dataIndex: "created_at",
      render: (created_at: string) => (
        <span>{created_at ? new Date(created_at).toLocaleString() : "-"}</span>
      ),
      sorter: (a, b) =>
        new Date(a.created_at).getTime() - new Date(b.created_at).getTime(),
    },
    {
      title: (
        <div className="settings">
          <i className="fa-solid fa-gear"></i>
        </div>
      ),
      key: "action",
      render: (_, record) => (
        <div className="settings_icons">
          <Popconfirm
            title="Bu abunəçini siləcəyinizə əminsiniz?"
            onConfirm={() => handleDeleteClick(record)}
            onCancel={() => message.info("Silmə əməliyyatı ləğv edildi.")}
            okText="Bəli"
            cancelText="Xeyr"
            placement="topRight"
          >
            <div className="delete">
              <i className="fa-solid fa-trash"></i>
            </div>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div id="pages">
      <Helmet>
        <title>1412 | Abunə olanlar</title>
      </Helmet>
      {loading ? (
        <Spinner />
      ) : (
        <div>
          <div className="page_head">
            <h3 className="page_title">Abunə olanlar</h3>
          </div>
          <div className="pages_components">
            <div className="pages_table">
              <Table
                scroll={{ x: "100%" }}
                columns={columns}
                dataSource={subscribers}
                rowKey={(record) => record.id.toString()}
                pagination={false}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Subscribers;

